import React, {FC} from 'react';
import {Teacher, TeacherRole, TeacherRoleNameMap} from '../../shared/types/teacher';
import {getAllTeachersFetch} from '../../app/axios/teacherFetches';
import HLModal, {HLModalSizeType} from '../../shared/components/modal/HLModal';
import HLPageTable, {HLPageTableFilterConfig} from '../../shared/components/table/HLPageTable';
import type {ColDef} from "ag-grid-community";

const searchFiltersConfig: HLPageTableFilterConfig<Teacher>[] = [
    {
        fieldName: 'firstName',
        label: 'Имя',
        operator: 'like',
    },
    {
        fieldName: 'lastName',
        label: 'Фамилия',
        operator: 'like',
    },
    {
        fieldName: 'login',
        label: 'Логин',
        operator: 'like',
    },
    {
        fieldName: 'role',
        label: 'Роль',
        operator: '=',
        type: 'select',
        options: Object.entries(TeacherRoleNameMap).map(([value, label]) => ({
            value,
            label
        }))
    },
];

const columnDefs: ColDef<Teacher>[] = [
    {
        field: 'firstName',
        headerName: 'Имя',
    },
    {
        field: 'lastName',
        headerName: 'Фамилия',
    },
    {
        field: 'login',
        headerName: 'Логин',
    },
    {
        field: 'role',
        headerName: 'Роль',
        valueFormatter: (params) => TeacherRoleNameMap[params.value as TeacherRole],
    }
];

const defaultColDef: ColDef<Teacher> = {
    sortable: false,
    filter: false,
    resizable: true,
    flex: 1,
    minWidth: 100
};

interface TeacherSearchModalProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    onSelect: (teacher: Teacher) => void;
}

const TeacherSearchModal: FC<TeacherSearchModalProps> = ({
                                                             open,
                                                             setOpen,
                                                             onSelect,
                                                         }) => {
    const handleRowClick = (params: any) => {
        if (params?.data) {
            onSelect(params.data);
            setOpen(false);
        }
    };

    const handleClose = () => setOpen(false);

    return (
        <HLModal open={open} onClose={handleClose} title="Выбрать учителя" sizeType={HLModalSizeType.LARGE}>
            <HLPageTable
                title=""
                columns={columnDefs}
                defaultColDef={defaultColDef}
                filterConfig={searchFiltersConfig}
                actionButtons={[]}
                fetchData={getAllTeachersFetch}
                height={485}
                onRowClick={handleRowClick}
            />
        </HLModal>
    );
};

export default TeacherSearchModal; 